/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Q = −10 × log10(P). Enter the error probability in the second field and the calculator returns the Q score.`)
};

const es_phred_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa Q = −10 × log10(P). Introduce la probabilidad de error en el segundo campo y la calculadora devuelve la puntuación Q.`)
};

const de_phred_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwenden Sie Q = −10 × log10(P). Geben Sie die Fehlerwahrscheinlichkeit in das zweite Feld ein, und der Rechner gibt den Q-Wert zurück.`)
};

const nl_phred_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruik Q = −10 × log10(P). Vul de foutkans in het tweede veld in en de calculator geeft de Q-score.`)
};

const fr_phred_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez Q = −10 × log10(P). Entrez la probabilité d'erreur dans le second champ et le calculateur renvoie le score Q.`)
};

const it_phred_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa Q = −10 × log10(P). Inserisci la probabilità di errore nel secondo campo e il calcolatore restituisce il punteggio Q.`)
};

const pt_br2_phred_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Q = −10 × log10(P). Informe a probabilidade de erro no segundo campo e a calculadora retorna o escore Q.`)
};

const pt_phred_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Q = −10 × log10(P). Introduza a probabilidade de erro no segundo campo e a calculadora devolve a pontuação Q.`)
};

const ja_phred_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q = −10 × log10(P) を使います。エラー確率を2番目のフィールドに入力すると、計算ツールがQスコアを返します。`)
};

const zh_phred_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 Q = −10 × log10(P)。在第二个字段中输入错误概率，计算器会返回 Q 分数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_faq_a4", locale)
	if (locale === "en") return en_phred_faq_a4(inputs)
	if (locale === "es") return es_phred_faq_a4(inputs)
	if (locale === "de") return de_phred_faq_a4(inputs)
	if (locale === "nl") return nl_phred_faq_a4(inputs)
	if (locale === "fr") return fr_phred_faq_a4(inputs)
	if (locale === "it") return it_phred_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_phred_faq_a4(inputs)
	if (locale === "pt") return pt_phred_faq_a4(inputs)
	if (locale === "ja") return ja_phred_faq_a4(inputs)
	return zh_phred_faq_a4(inputs)
};